// Remove class on html tag after page is loaded (the class is added with js in the header)
// Not sure we're using this but yeah whatever

window.addEventListener("load", function() {
    if (document.documentElement.className.match(/(?:^|\s)preload(?!\S)/)) {
        document.documentElement.className = document.documentElement.className.replace
    ( /(?:^|\s)preload(?!\S)/g , '' );
    }
});


// MENU TOGGLE

document.querySelector("#js-menutoggle").addEventListener("click", function(event) {
    event.preventDefault();
    var currentScrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    
    this.classList.toggle("active");
    document.body.classList.toggle("js-menu-active");
    
    // Restore the scroll position after a short delay to allow the layout to adjust
    setTimeout(function() {
      window.scrollTo(0, currentScrollPos);
    }, 0);
});


// PARALLAX (Load the parallax thing - simpleParallax.min.js)
// Found in base.twig

document.addEventListener('DOMContentLoaded', function () {
    const images = document.querySelectorAll('.js-parallax');
    new simpleParallax(images, {
        scale: 1.1
    });
});

// konfigurator
// need contact form 7 with id=konfigurator in hidden field
function setConfiguratorValue(elem, url) {
    if (elem && url) {
        const urlobj=new URL(url, window.location.href);
        const params = urlobj.searchParams;
        const size = params.get("projectSize");
        if (size) elem.value += "Boka tid angående [" + size +"]";
        else "Boka tid angående konfigurator.";
    }
}
document.addEventListener('DOMContentLoaded',function() {
    // for page, see also modal
    setConfiguratorValue(document.getElementById('konfigurator'), window.location.href);
});


// LIGHT/DARK/SYSTEM SWITCH - Define the theme functions

function toDarkMode() {
    localStorage.theme = 'dark';
    document.documentElement.classList.add('dark');
    document.documentElement.setAttribute('color-theme', 'dark');
    window.updateWaveSurferColors();
}

function toLightMode() {
    localStorage.theme = 'light';
    document.documentElement.classList.remove('dark');
    document.documentElement.setAttribute('color-theme', 'light');
    window.updateWaveSurferColors();
}

function toSystemMode() {
    localStorage.theme = 'system';
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        document.documentElement.classList.add('dark');
    } else {
        document.documentElement.classList.remove('dark');
    }
    document.documentElement.setAttribute('color-theme', 'system');
    window.updateWaveSurferColors();
}


// Attach these functions to the window object
window.toDarkMode = toDarkMode;
window.toLightMode = toLightMode;
window.toSystemMode = toSystemMode;

// Update theme based on localStorage
function updateTheme() {
    if (!('theme' in localStorage)) {
        localStorage.theme = 'system';
    }

    switch (localStorage.theme) {
        case 'system':
            if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
                document.documentElement.classList.add('dark');
            } else {
                document.documentElement.classList.remove('dark');
            }
            document.documentElement.setAttribute('color-theme', 'system');
            break;
        case 'dark':
            document.documentElement.classList.add('dark');
            document.documentElement.setAttribute('color-theme', 'dark');
            break;
        case 'light':
            document.documentElement.classList.remove('dark');
            document.documentElement.setAttribute('color-theme', 'light');
            break;
    }
}

// Call updateTheme to initialize the theme when the script loads
updateTheme();



// LIGHTBOX (used in ACF -> _standard_section_repeater -> image_lightbox )

document.addEventListener('click', function(event) {
    if (event.target && event.target.classList.contains('js-lightbox')) {
        openLightbox(event.target);
    }
});

function openLightbox(thumbnail) {
    const lightbox = document.querySelector('.js-lightbox-wrap');
    const lightboxImg = document.getElementById('lightbox-img');
    const thumbnailRect = thumbnail.getBoundingClientRect();
    const scaleWidth = thumbnailRect.width / window.innerWidth;
    const scaleHeight = thumbnailRect.height / window.innerHeight;
    const offsetX = thumbnailRect.left - (window.innerWidth / 2) + (thumbnailRect.width / 2);
    const offsetY = thumbnailRect.top - (window.innerHeight / 2) + (thumbnailRect.height / 2);

    // Set the source to the high-res image
    lightboxImg.src = thumbnail.getAttribute('data-highres');
    lightboxImg.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scaleWidth}, ${scaleHeight})`;
    lightbox.style.display = 'flex';
    setTimeout(() => {
        lightbox.classList.add('open');
        lightboxImg.style.transform = 'translate(0, 0) scale(1, 1)';
    }, 10);

    // Remember the current scroll position
    const scrollY = window.scrollY;
    document.body.style.top = `-${scrollY}px`;
    document.body.classList.toggle("js-lightbox-active");
}

function closeLightbox() {
    const lightbox = document.querySelector('.js-lightbox-wrap');
    lightbox.classList.remove('open');
    setTimeout(() => {
        lightbox.style.display = 'none';
    }, 300);

    // Restore the original position and scroll
    const scrollY = document.body.style.top;
    document.body.classList.toggle("js-lightbox-active");
    document.body.style.top = '';
    window.scrollTo(0, -parseInt(scrollY || '0'));
}


// MODAL (trycker upp en kontaktruta)

document.addEventListener('click', function(event) {
    if (event.target.closest('.js-modal') !== null) {
        let modal_opener=event.target.closest('.js-modal');
        let modalId = modal_opener.getAttribute('data-modal');
        let formId = modal_opener.getAttribute('data-cf7');
        // Pass the modal ID to the openModal function
        if (formId) generateForm(formId,modalId,modal_opener);
        else openModal(modalId);
        event.preventDefault();
    }
});

function generateForm(formId,modalId,opener_element) {
    let opener_url=opener_element.getAttribute("href");
    if (opener_url) opener_url=opener_url.replace(/^#/,"/");
    //if (window.location.href.match(/^http:\/\/hf.q/) formId="0b3b22b"; // Elins lokala test!!
    let data = 'action=generate_form';
    data += '&formId='+encodeURIComponent(formId);
    const xhr = new XMLHttpRequest();
    xhr.open('POST', ajaxurl, true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.onreadystatechange = function (res) {
        if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
            var res = JSON.parse(xhr.responseText);
            let currentmodal=openModal(modalId);
            let modalcontent=currentmodal.getElementsByClassName('js-modalcontent');
            modalcontent[0].innerHTML=res.data.html;
            let form_element=modalcontent[0].getElementsByClassName('wpcf7-form')[0];
            wpcf7.init(form_element);
            setConfiguratorValue(form_element.konfigurator,opener_url);
            // message and close button after submit:
            modalcontent[0].addEventListener( 'wpcf7mailsent', function( event ) {
                try {
                    // show output an close message:
                    let closemsg=modalcontent[0].parentElement.getElementsByClassName('js-modalclose')[0];
                    closemsg.style.display="block";
                    closemsg.getElementsByTagName('span')[0].innerText=event.detail.apiResponse.message; // see all with console.log(event.detail);
                    modalcontent[0].appendChild(closemsg);
                    // hide form:
                    form_element.style.display="none";
                } catch {
                    console.log('Ojdå - stängknappen saknas');
                }
            }, false );
        }
    }
    xhr.send(data);
}

function openModal(modalId) {
    // Use the modal ID to select the correct modal
    const modal = document.getElementById(modalId);

    // Remember the current scroll position
    const scrollY = window.scrollY;
    document.body.style.top = `-${scrollY}px`;

    modal.classList.add('open');
    document.body.classList.toggle("js-modal-active");

    return modal;
}

function closeModal() {
    const modal = document.querySelector('.js-modal-wrap.open');
    if (!modal) return; // Guard clause in case there's no open modal
    modal.classList.remove('open');
    // setTimeout(() => {
    //     modal.style.display = 'none';
    // }, 300);

    // Restore the original position and scroll
    const scrollY = document.body.style.top;
    document.body.classList.toggle("js-modal-active");
    document.body.style.top = '';
    window.scrollTo(0, -parseInt(scrollY || '0'));
}


// ACCORDION

document.addEventListener('DOMContentLoaded', function() {
    const accordions = document.querySelectorAll('[data-behavior="accordion"]');
    const expandedClass = 'is-expanded';

    accordions.forEach((accordion, accordionIndex) => {
        const accordionItems = accordion.querySelectorAll('[data-binding="expand-accordion-item"]');
        
        accordionItems.forEach((item, itemIndex) => {
            const triggerBtn = item.querySelector('[data-binding="expand-accordion-trigger"]');
            const content = item.querySelector('[data-binding="expand-accordion-container"]');
            
            // Generate unique IDs
            const tabId = `tab${itemIndex + 1}`;
            const panelId = `panel${itemIndex + 1}`;
            
            // Set IDs and ARIA attributes
            triggerBtn.setAttribute('id', tabId);
            triggerBtn.setAttribute('aria-controls', panelId);
            triggerBtn.setAttribute('aria-selected', 'false');
            triggerBtn.setAttribute('aria-expanded', 'false');
            triggerBtn.setAttribute('role', 'tab');
            triggerBtn.setAttribute('tabindex', '0');
            
            content.setAttribute('id', panelId);
            content.setAttribute('aria-labelledby', tabId);
            content.setAttribute('aria-hidden', 'true');
            content.setAttribute('role', 'tabpanel');
            
            const setHeight = (element) => {
                const innerContent = element.querySelector('.accordion__content-inner');
                const content = element.querySelector('.accordion__content');
                const maxHeight = innerContent.offsetHeight;
                
                if (!content.style.height || content.style.height === '0px') {
                    content.style.height = `${maxHeight}px`;
                } else {
                    content.style.height = '0px';
                }
            };
            
            const toggleClasses = (event) => {
                const clickedItem = event.currentTarget;
                const currentItem = clickedItem.parentElement;
                const clickedContent = currentItem.querySelector('.accordion__content');
                
                currentItem.classList.toggle(expandedClass);
                setHeight(currentItem);
                
                if (currentItem.classList.contains('is-expanded')) {
                    clickedItem.setAttribute('aria-selected', 'true');
                    clickedItem.setAttribute('aria-expanded', 'true');
                    clickedContent.setAttribute('aria-hidden', 'false');
                } else {
                    clickedItem.setAttribute('aria-selected', 'false');
                    clickedItem.setAttribute('aria-expanded', 'false');
                    clickedContent.setAttribute('aria-hidden', 'true');
                }
            };
            
            // Click event listener
            triggerBtn.addEventListener('click', (e) => {
                e.preventDefault();
                toggleClasses(e);
            });
            
            // Keyboard event listener for Enter and Space
            triggerBtn.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleClasses(e);
                }
            });
        });
    });
});




// PLAUSIBLE (click tracking)

document.addEventListener('DOMContentLoaded', function() {
    // Primary Buttons
    var primaryButtons = document.querySelectorAll('.c-button--primary');
    primaryButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
            var linkcontent = btn.innerText;
            var pageTitle = document.title;
            plausible('Event-ButtonClick', { props: { Title: linkcontent, Page: pageTitle } });
        });
    });

    // Menu Items
    var menuItems = document.querySelectorAll('.menu-item a');
    menuItems.forEach(function(btn) {
        btn.addEventListener('click', function() {
            var linkcontent = btn.innerText;
            var pageTitle = document.title;
            plausible('Event-MenuItemClick', { props: { Title: linkcontent, Page: pageTitle } });
        });
    });

    // Newsletter
    var menuItems = document.querySelectorAll('.newsletterSubmit');
    menuItems.forEach(function(btn) {
        btn.addEventListener('click', function() {
            var pageTitle = document.title;
            plausible('Goal-NewsletterSubscribe', { props: { Page: pageTitle } });
        });
    });

    // Video Items
    var menuItems = document.querySelectorAll('.js-play');
    menuItems.forEach(function(btn) {
        btn.addEventListener('click', function() {
            var pageTitle = document.title;
            plausible('Event-VideoClick', { props: { Page: pageTitle } });
        });
    });

    // Leta upp alla länkar med attributet data-tracking, och om det finns även data-tracking-value
    var trackableItems = document.querySelectorAll('[data-tracking]');
    trackableItems.forEach(function(item) {
        item.addEventListener('click', function() {
            var pageTitle = document.title;
            var eventName = item.dataset.tracking;
            var props = { Page: pageTitle };
            
            // Check if data-tracking-value exists and add it to props if it does
            if (item.dataset.trackingValue !== undefined) {
                props.Value = item.dataset.trackingValue;
            }
            
            plausible(eventName, { props: props });
        });
    });
});


// VIDEO PLAYER (för kontaktvideos i _offer_top.twig , oklart om dessa kommer användas i framtiden)

const jsActiveClass = 'js-active';
const helloVideos = document.querySelectorAll('.js-hellovideo');
helloVideos.forEach(helloVideo => {
    const video = helloVideo.querySelector('.js-video');
    const playButton = helloVideo.querySelector('.js-play');
    let currentVideo;

    playButton.addEventListener('click', function() {
        if (currentVideo && currentVideo !== video) {
            currentVideo.pause();
            playButton.classList.remove(jsActiveClass);
        }
        currentVideo = video;
        if (video.paused) {
            video.play();
            playButton.classList.add(jsActiveClass);
        } else {
            video.pause();
            playButton.classList.remove(jsActiveClass);
        }
    });

    video.addEventListener('ended', function() {
        playButton.classList.remove(jsActiveClass);
    });
});



// ARTICLE FILTERING (latest_posts.twig)

const container = document.querySelector('.js-posts-filter-container');
const loadMoreBar = document.querySelector('.js-read-more-bar');
const postsContainer = document.querySelector('.js-posts-container');
// const postType = container.classList.contains('latest_projects') ? 'project' : 'post';

async function setFilterPosts(args) {
    const baseUrl = container.getAttribute('data-base-url');
    const url = `/wp-admin/admin-ajax.php`;

    // Show loading
    postsContainer.classList.add('cursor-progress');
    const minTimePromise = new Promise(resolve => setTimeout(resolve, 700)); // Ensures loader shows for at least 700ms

    try {
        const response = await Promise.all([
            fetch(url, {
                method: 'POST', // or 'GET'
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: encodeDataArgs(args),
            }),
            minTimePromise
        ]);

        const responseData = await response[0].json();
        postsContainer.innerHTML = responseData.output;

        handlePostCount(responseData.post_count);
        updateURL(args.category);
    } catch (error) {
        console.error('Error loading posts:', error);
    } finally {
        // Hide loading
        postsContainer.classList.remove('cursor-progress');
    }
}

function encodeDataArgs(args) {
    return Object.keys(args)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(args[key]))
        .join('&');
}

function handlePostCount(postCount) {
    if(!postCount) {
        postsContainer.classList.add('no-posts-found');
    } else {
        postsContainer.classList.remove('no-posts-found');
    }
    if(postCount <= 100) {
        loadMoreBar.style.display = 'none';
    } else {
        loadMoreBar.style.display = 'block';
    }
}

function updateURL(category) {
    let newUrl = window.location.href.split('?')[0];
    if(category !== 'all' && category.split(',').length === 1) {
        newUrl += `?category=${category}`;
    }
    window.history.pushState({}, document.title, newUrl);
}

document.querySelectorAll('.js-filters li').forEach(filter => {
    filter.addEventListener('click', async (e) => {
        e.preventDefault();
        filter.classList.add('!bg-yellow-15');
        filter.classList.add('!dark:!bg-orange-70');
        filter.siblings.forEach(sibling => sibling.classList.remove('!bg-yellow-15'));
        filter.siblings.forEach(sibling => sibling.classList.remove('!dark:!bg-orange-70'));

        const args = {
            action: "filterposts",
            // post_type: postType,
            category: filter.getAttribute('data-filter')
        };
        await setFilterPosts(args);
    });
});

// Fix for sibling selector
Object.defineProperty(Element.prototype, 'siblings', {
    get: function() {
        return Array.prototype.filter.call(this.parentNode.children, (child) =>
            child !== this
        );
    },
});


// HORISONTAL SCROLL (Check if the list of articles include more than five items, then create a nice fade out effect with css)

document.addEventListener("DOMContentLoaded", function() {
    const articleLists = document.querySelectorAll('.js-article-list');

    articleLists.forEach(articleList => {
        const articleListContainer = articleList.closest('.js-scrollarea');
        if (articleListContainer) {
            const childCount = articleList.children.length;

            if (childCount > 5) {
                articleListContainer.classList.add('js-more-than-five');
            } else if (childCount > 4) {
                articleListContainer.classList.add('js-more-than-four');
            }
        }
    });
});

// Scroll horisontal content on wider screens

document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth > 1024) { // only load on wider screens
        const scrollContainers = document.querySelectorAll('.js-scrollable-content');

        scrollContainers.forEach(container => {
            // Target the .js-article-list more accurately
            const articleList = container.querySelector('.js-article-list');
            articleList.style.overflowX='hidden';
            const leftBtn = container.querySelector('.js-scroll-btn-left');
            const rightBtn = container.querySelector('.js-scroll-btn-right');
            // Function to toggle visibility of scroll buttons
            function toggleScrollButtons() {
                leftBtn.style.display = articleList.scrollLeft > 0 ? 'block' : 'none';
                rightBtn.style.display = articleList.scrollLeft + articleList.offsetWidth < articleList.scrollWidth ? 'block' : 'none';
            }

            // Initial toggle to hide or show buttons
            toggleScrollButtons();

            // Function to smoothly scroll the article list
            function smoothScroll(amount) {
                articleList.scrollBy({ left: amount, behavior: 'smooth' });
            }

            // Add event listeners for buttons
            rightBtn.addEventListener('click', () => {
                smoothScroll(300); // Adjust the scroll amount as needed
                setTimeout(toggleScrollButtons, 300); // Adjust delay based on animation duration
            });

            leftBtn.addEventListener('click', () => {
                smoothScroll(-200); // Adjust the scroll amount as needed
                setTimeout(toggleScrollButtons, 300); // Adjust delay based on animation duration
            });

            // Add event listener for scroll event to manage button visibility
            articleList.addEventListener('scroll', toggleScrollButtons);
        });
    };
});
